export const isAuthenticated = () => {
  localStorage.removeItem("currentUser");
};
